import { useState, useEffect } from 'react';
export const usePageVisibility = () => {
    const [isVisible, setIsVisible] = useState(!document.hidden);
    useEffect(() => {
        const listener = () => setIsVisible(!document.hidden);
        document.addEventListener('visibilitychange', listener, false);
        return () => document.removeEventListener('visibilitychange', listener);
    }, []);
    return {
        isVisible
    };
};
//# sourceMappingURL=usePageVisibility.js.map